const state = {
    loading: false,
    elearn: [],
};

export default state;